import PropTypes from 'prop-types'
import EtapForm from "../parts/EtapForm.jsx";

export const EtapRealizacji = (props) => {
    return <EtapForm wiz={props.wiz} etapKey="realizacja" />
}

EtapRealizacji.propTypes = {
    wiz: PropTypes.any,
}